import PageMainTitle from 'components/commons/PageMainTitle'
import { pageMainTitle } from 'components/mvv/Mvv/BrandItems'
import styles from './Brand.module.scss'
import CaseStudy from 'components/home/CaseStudy'
import Column from 'components/home/Column'
import OurMission from 'components/mvv/OurMission'
import OurVision from 'components/mvv/OurVision'
import OurValue from 'components/mvv/OurValue'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const Brand: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'About', url: '/about' },
    { name: '当社が目指しているもの', url: '#' },
  ]

  return (
    <article>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
      <div>
        <OurVision />
        <OurMission />
        <OurValue />
      </div>
      <Column tagType="h2" />
      <MailmagazineLink />
    </article>
  )
}

export default Brand
